import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { getIn } from 'formik'

import MinimisedSection from '../../../../../../../../components/MinimisedSection'
import MinimisedSectionHeader from '../../../../../../../../components/MinimisedSection/MinimisedSectionHeader'
import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../components/Form/Field'
import JavascriptTagFields from './JavascriptTagFields'

import { AD_CREATIVES, NAME, THIRD_PARTY_TAG } from '../../../../../fields'

import {
  DISPLAY_DEFAULT,
  VIDEO_DEFAULT
} from '../../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useStyles from './styles'

const AdCreativeTagSection = ({
  formik,
  index,
  isSelected,
  onSelect,
  onClose,
  onDelete,
  allowDelete,
  lineItemType
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { values } = formik

  const sectionTitle = useMemo(() => {
    const adCreativeName = getIn(values, `${AD_CREATIVES}[${index}][${NAME}]`)
    return adCreativeName || `Ad Creative ${index + 1}`
  }, [values, index])

  const onClickHandler = useCallback(() => {
    if (isSelected) {
      onClose()
    } else {
      onSelect()
    }
  }, [isSelected, onSelect, onClose])

  return (
    <MinimisedSection
      headerContent={<MinimisedSectionHeader title={t(sectionTitle)} onDelete={allowDelete ? onDelete : null} />}
      isOpened={isSelected}
      onHeaderClick={onClickHandler}
    >
      <FieldLabelWrapper
        label={t('Name')}
        labelFor={`${AD_CREATIVES}[${index}][${NAME}]`}
        className={classes.nameFieldWrapper}
      >
        <Field placeholder={t('Name')} formik={formik} name={`${AD_CREATIVES}[${index}][${NAME}]`} />
      </FieldLabelWrapper>
      {lineItemType === DISPLAY_DEFAULT && <JavascriptTagFields formik={formik} index={index} />}

      {lineItemType === VIDEO_DEFAULT && (
        <FieldLabelWrapper label={t('VAST Tag')} labelFor={`${AD_CREATIVES}[${index}][${THIRD_PARTY_TAG}]`}>
          <Field
            placeholder={t('VAST Tag')}
            formik={formik}
            name={`${AD_CREATIVES}[${index}][${THIRD_PARTY_TAG}]`}
            isTextarea={true}
          />
        </FieldLabelWrapper>
      )}
    </MinimisedSection>
  )
}

AdCreativeTagSection.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  lineItemType: PropTypes.string.isRequired
}

export default AdCreativeTagSection
